import React, { useEffect, useRef } from "react";

const GoogleAd = ({
  adSlot = "5678184118", // Tu peux changer ici selon ton slot
  adFormat = "auto",
  style = { display: "block" },
}) => {
  const adRef = useRef(null);

  useEffect(() => {
    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      ref={adRef}
      style={style}
      data-ad-client="ca-pub-6858524654473003"
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      data-full-width-responsive="true"
    />
  );
};

export default GoogleAd;
